import { api } from "@/services/api"
import { queryClient } from "@/queryClient"

export type CreateNotificationRequest = {
  fromDatetime: Date | string
  untilDatetime: Date | string
  contents: string
  sendToTerminal: boolean
  sendToPortal: boolean
}

export const createNotification = async (
  params: CreateNotificationRequest
) => {
  await api.post("/notifications/", {
    body: params,
  })

  queryClient.invalidateQueries([
    BASE_NOTIFICATIONS_QUERY_KEY,
  ])
}
